<template>
    <tbody v-if="wp">
        <tr>
            <td colspan="2"><h2>WordPress Information</h2></td>
        </tr>
        <tr>
            <td>Site URL:</td>

            <td>{{ wp.site_url }}</td>
        </tr>

        <tr>
            <td>WP Version:</td>

            <td>{{ wp.version }}</td>
        </tr>
        <tr>
            <td>WP Multisite:</td>

            <td>{{ wp.multisite }}</td>
        </tr>
        <tr>
            <td>WP Memory Limit:</td>

            <td>{{ wp.memory_limit }}</td>
        </tr>
        <tr>
            <td>WP Debug Mode:</td>

            <td>
                <template v-if="wp.debug_mode"><span class="dashicons dashicons-yes"></span> Yes</template>
                <template v-else><span class="dashicons dashicons-no"></span> No</template>
            </td>
        </tr>
        <tr>
            <td>WP Debug Log Active:</td>

          <td>
            <template v-if="wp.debug_log_active"><span class="dashicons dashicons-yes"></span> Yes</template>
            <template v-else><span class="dashicons dashicons-no"></span> No</template>
          </td>
        </tr>

        <tr>
            <td>WP Debug Log file location:</td>

            <td>
              {{ wp.debug_log_file_location }}
            </td>
        </tr>


        <tr>
            <td>WP Cron:</td>

          <td>
            <template v-if="wp.disable_cron"><span class="dashicons dashicons-no"></span> No</template>
            <template v-else><span class="dashicons dashicons-yes"></span> Yes</template>
          </td>
        </tr>

        <tr>
            <td>Language:</td>

            <td>{{ wp.locale }}</td>
        </tr>

        <tr>
            <td>Upload Directory  Location:</td>

            <td>{{ wp.upload_directory_location }}</td>
        </tr>
    </tbody>
</template>
<script>
export default {
    name: 'WordPressInfo',

    props: ['wp']
};
</script>
